import React from "react";
import { Input, FormControl, FormErrorMessage } from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";
import useTranslation from "next-translate/useTranslation";
import { FormLabel } from "src/shared/components/FormLabel";

const SmileSignupValidatePasswordInput = () => {
  const { t } = useTranslation();
  const { register, errors, watch } = useFormContext();

  return (
    <FormControl id="validatePassword" isInvalid={!!errors.validatePassword} isRequired>
      <FormLabel>{t("smile:pixSignup_confirmPasswordLabel")}</FormLabel>
      <Input
        ref={register({
          required: t("smile:form_formRequiredField"),
          validate: (v) => v === watch("password") || t("smile:form_formPasswordMismatch"),
        })}
        name="validatePassword"
        type={"password"}
        placeholder="******"
        height={"50px"}
        bg={"rgba(255, 255, 255, 0.8)"}
        border={"1px solid"}
        borderColor={"#BBD1F2"}
        borderRadius={"2px"}
        boxShadow={"0px 20px 32px rgba(70, 25, 164, 0.05)"}
        fontFamily="Montserrat"
        fontSize={"14px"}
        fontWeight={"500"}
        lineHeight={"110%"}
      />
      <FormErrorMessage>{errors.validatePassword && errors.validatePassword.message}</FormErrorMessage>
    </FormControl>
  );
};

export default SmileSignupValidatePasswordInput;
